<template>
  <div v-if="currentFlowStep === signupFlowSteps.enterDetails">
    <introduction-with-promo v-if="promotion" :next="() => setCurrentFlowStep(signupFlowSteps.enterCode)"/>
    <introduction v-else :next="() => setCurrentFlowStep(signupFlowSteps.enterCode)"/>
  </div>
  <signup-enter-code v-else-if="currentFlowStep === signupFlowSteps.enterCode"
                     :next="onEnterCode"/>
  <whatsapp-opt-in v-else-if="currentFlowStep === signupFlowSteps.whatsappOptin && !syncOnboarding"
                   :next="gotToOnboard" />
</template>

<script>

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntroductionWithPromo from '@/pages/responsive-pages/non-authenticated/wine-and-dine/signup/steps/IntroductionWithPromo';
import SubscriptionStateApi from '@/api/SubscriptionStateApi';
import Introduction from './steps/Introduction.vue';
import SignupEnterCode from './steps/SignupEnterCode.vue';
import WhatsappOptIn from './steps/WhatsappOptIn.vue';
import router from '../../../../../router';
import featureFlag from '../../../../../api/featureFlag';

export default {
  name: 'SignupFlow',
  components: {
    WhatsappOptIn,
    Introduction,
    SignupEnterCode,
    IntroductionWithPromo,
  },
  async created() {
    this.setCurrentFlowStep(this.signupFlowSteps.enterDetails);
    if (this.promoCode) {
      await this.fetchPromotion(this.promoCode);
    }
  },
  data() {
    return {
      syncOnboarding: false,
    };
  },
  props: {
    promoCode: {
      type: String,
    },
  },
  computed: {
    ...mapState('signup', ['currentFlowStep', 'SIGNUP_ERRORS', 'error']),
    ...mapState('promotions', ['promotion']),
    ...mapGetters('signup', ['signupFlowSteps']),
  },
  methods: {
    ...mapMutations('signup', ['setCurrentFlowStep']),
    ...mapActions('promotions', ['fetchPromotion']),
    gotToOnboard() {
      router.push({ path: '/onboard' });
    },
    async onEnterCode() {
      if (this.promotion) {
        await SubscriptionStateApi.createBenefit(this.promotion);
      }
      this.syncOnboarding = (await featureFlag.getTreatment('sync-onboarding')) === 'on';
      if (this.syncOnboarding) {
        router.push({ path: '/ob' });
      } else {
        this.setCurrentFlowStep(this.signupFlowSteps.whatsappOptin);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
